import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class LoadDetailFilter {
  logon:any = "matte";
  scac:any = "demo";
  fromDate: NgbDate = null;
  toDate: NgbDate = null;
  drsStartDate: string = null;
  drsEndDate: string = null;
}
